var alignment_default = {
  "alignLeft": "Qw6Nl",
  "textWrapNowrap": "yvE9v",
  "alignRight": "b7pBz",
  "alignCenter": "zMZxR",
  "sizeFullWidth": "Npok7",
  "renderedInTable": "_63NdG",
  "sizeOriginal": "cARYq",
  "sizeContent": "KhMe-",
  "sizeSmall": "_3Ju4k",
  "sizeSmallCenter": "Yi8Zn",
  "flex": "YCFOa",
  "LEFT": "Y8AZ7",
  "CENTER": "HueUO",
  "RIGHT": "sxfLy",
  "AUTO": "cIXLT",
  "JUSTIFY": "I66n0"
};
export {
  alignment_default as default
};
//# sourceMappingURL=alignment-scss.js.map
